import { render, staticRenderFns } from "./ppanel.vue?vue&type=template&id=6f43f5f6"
import script from "./ppanel.vue?vue&type=script&lang=js"
export * from "./ppanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports